export default __webpack_public_path__ + "static/media/icone-inicio.ec807cc5.svg";